import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_X_API_KEY_ACCOUNTING_ENTRIES_REPORT
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ACCOUNTING_ENTRIES_REPORT,
  headers: { ...header }
})